
    import "src/shared/components/GoogleMap/index.module.scss?farm_css_modules";
    
    export default {"col": `col-7c06770c`,"details": `details-7c06770c`,"gMapModal": `gMapModal-7c06770c`,"image": `image-7c06770c`,"left-text": `left-text-7c06770c`,"mapWrap": `mapWrap-7c06770c`,"marker": `marker-7c06770c`,"row1-row": `row1-row-7c06770c`,"text": `text-7c06770c`,"topHeading": `topHeading-7c06770c`}
    